import ProductInfoCard from './productInfoCard.container';
export default ProductInfoCard